import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import TimelineCharts from '@blade-sxp/monitor/components/echarts/timeline-charts.vue';
let default_1 = class default_1 extends Vue {
    dataSeries;
    dataX;
    timeType;
    get option() {
        return {
            title: {
                text: this.$t('inLine'),
                show: true,
                textStyle: {
                    // 主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                    fontFamily: 'Arial, Verdana, sans...',
                    fontSize: 13,
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    color: '#485465',
                },
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(255,255,255,0.95)',
                textStyle: {
                    color: '#00000',
                },
                extraCssText: 'box-shadow:0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
                formatter: (param) => {
                    const series1 = param[0].marker + param[0].seriesName + ':' + param[0].value + '<br/>';
                    const series2 = param[1].marker + param[1].seriesName + ':' + `${param[1].value}${this.$t('min').toString()}` + '<br/>';
                    const series3 = param[2].marker + param[2].seriesName + ':' + `${param[2].value}${this.$t('peopleMin').toString()}`;
                    const res = param[0].axisValue + '<br/>' + series1 + series2 + series3;
                    return res;
                },
            },
            legend: {
                right: 10,
                data: [this.$t('inLine'), this.$t('abandonedNumber'), this.$t('queuingTime')],
            },
            dataZoom: [
                {
                    type: 'slider',
                    start: 0,
                    end: 100,
                    width: '80%',
                    left: '10%',
                    handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                    brushSelect: false, // 是否开启刷选功能,默认true
                },
            ],
            grid: {
                left: '1%',
                right: '2%',
                bottom: '10%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: this.dataX,
                axisLabel: {
                    show: true,
                },
            },
            yAxis: {
                type: 'value',
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dashed',
                    },
                },
            },
            series: [
                {
                    name: this.$t('inLine'),
                    type: 'line',
                    // stack: '总量',
                    data: [],
                    itemStyle: {
                        normal: {
                            color: '#2FC25B',
                            lineStyle: {
                                color: '#2FC25B', // 折线颜色
                            },
                        },
                    },
                },
                {
                    name: this.$t('abandonedNumber'),
                    type: 'line',
                    // stack: '总量',
                    data: [],
                    itemStyle: {
                        normal: {
                            color: '#FA6400',
                            lineStyle: {
                                color: '#FA6400', // 折线颜色
                            },
                        },
                    },
                },
                {
                    name: `${this.$t('queuingTime')}`,
                    type: 'line',
                    // stack: '总量',
                    data: [],
                    itemStyle: {
                        normal: {
                            color: '#0091FF',
                            lineStyle: {
                                color: '#0091FF', // 折线颜色
                            },
                        },
                    },
                },
            ],
        };
    }
    handleResize() {
        this.$refs.refCharts && this.$refs.refCharts.onResize();
    }
    onDataZoomChange(timeStart, timeEnd) {
        // console.log("timeZoom:", this.timeZoom);
        this.$emit('on-data-zoom-change', timeStart, timeEnd);
    }
};
__decorate([
    Prop()
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop()
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "timeType", void 0);
default_1 = __decorate([
    Component({
        name: 'NumbersCharts',
        components: {
            TimelineCharts,
        },
        i18n: {
            messages: {
                'en-us': {
                    inLine: 'Queues People Number',
                    queuingTime: 'Average Velocity',
                    abandonedNumber: 'Average Waiting Time',
                    min: 'Min',
                    peopleMin: 'ppl/min',
                },
                zh: {
                    inLine: '排队人数',
                    queuingTime: '排队通行速度',
                    abandonedNumber: '预计排队时长',
                    min: '分',
                    peopleMin: '人/分',
                },
            },
        },
    })
], default_1);
export default default_1;
